import { IconButton as UiIconButton, styled } from "@l2r-front/l2r-ui"

export const IconButton = styled(UiIconButton)(() => ({
    padding: 0,
}))